// The full preprocess pipeline for assistant-authored Markdown: table
// delimiter repair, then split-decimal repair. Used by the chat renderer
// (Streamdown `preprocess`) and by the Markdown export so both agree.

import { normalizeMarkdownTables } from './normalizeMarkdownTables';
import { normalizeSplitDecimals } from './normalizeSplitDecimals';

export function normalizeAssistantMarkdown(markdown: string): string {
  return normalizeSplitDecimals(normalizeMarkdownTables(markdown));
}
